<ng-container *ngIf="isScreenLarge; else mobileLayout">
  <span style="padding-left: 15px;">
    <button mat-button (click)="openAnalysisOptions(analysisOptionsDialog)" [disabled]="isCreatingProject"
      style="color: #EEA21A; font-size: 14px; font-family: 'Inter'; font-weight: 600;">
      <img style=" 
    padding-bottom: 4px;
    vertical-align: middle;
    height: 20px;
    width: 20px;" src="./assets/images/yellow_icons/analysis-icon.svg">
      Analysis Options
    </button>
  </span>



  <!-- Contenido del Modal -->
  <ng-template #analysisOptionsDialog>

    <div
      style="background-color: #F3F3F5;width: auto; height: auto; display: flex; justify-content: flex-end; padding: 0; margin: 0;">
      <button class="close-button" mat-dialog-close>
        <img src="./assets/images/close-icon.svg">
      </button>
    </div>




    <mat-dialog-content class="mat-dialog-content">

      <div class="select-container">
        <label for="englishType">English type</label>
        <select id="englishType" name="englishType" class="custom-select" [value]="englishType"
          (change)="onEnglishTypeChange($event)">
          <option value="british">British English</option>
          <option value="american">American English</option>
        </select>
      </div>

      <div style="display: flex; flex-direction: column; align-items: flex-start; width: 100%;">

        <div class="select-container">
          <label for="analysisMode">Analysis mode</label>
          <select id="analysisMode" name="analysisMode" class="custom-select" [value]="analysisMode"
            (change)="onAnalysisModeChange($event)">
            <option value="Writing">Writing</option>
            <option value="Reading">Reading</option>
            <option value="Listening">Listening</option>
          </select>
        </div>
      </div>

      <div style="display: flex; flex-direction: column; align-items: flex-start; width: 100%;">

        <div class="select-container">
          <label for="targetCEFR">Target overall CEFR Score for your text</label>
          <select id="targetCEFR" name="targetCEFR" class="custom-select" [value]="targetCEFR"
            (change)="onTargetCEFRChange($event)">
            <option value="A1">A1</option>
            <option value="A2">A2</option>
            <option value="B1">B1</option>
            <option value="B2">B2</option>
            <option value="C1">C1</option>
            <option value="C2">C2</option>
          </select>
        </div>
      </div>

      <button class="main-box-value-14 button-settings" style="color:#EEA21A; text-align: center; align-items: center;"
        [ngClass]="{'expanded': isExpanded}" (click)="toggleExpand()">Advanced Settings <mat-icon class="expand-icon"
          style="order:3;">expand_more</mat-icon></button>

      <div *ngIf="isExpanded">
        <div style="display: flex; flex-direction: column; align-items: flex-start;margin-top: 8px;">
          <span for="sizeType">Split documents at this character
            <div class="tooltip-container">
              <img class="tooltip-icon" src="../assets/images/tooltip-icon.svg">
              <span class="tooltip-text">You can input multiple texts into Text Inspector. This option allows you to choose which character serves as a delimiter between each text.</span>
            </div>
          </span>

          <div class="custom-text-container">
            <input 
              type="text" 
              id="customInput" 
              class="custom-text-input" 
              [(ngModel)]="splitCharacter"  
              [readonly]="isProjectCreated"
              [ngStyle]="{ 'pointer-events': isProjectCreated ? 'none' : 'auto' }"
              (change)="onSplitCharacterChange($event)">


          </div>
        </div>
        <mat-checkbox color="accent" [checked]="excludeDigits" (change)="onExcludeDigitsChange($event)" disableRipple>Exclude all digits</mat-checkbox>
        <div class="horizontal-box analysis-known-words-row" style="border: none; padding: 0px; margin-bottom: -10px; ">
          <mat-checkbox class="analysis-known-words-checkbox" color="accent" [checked]="useKnownWords" (change)="onUseKnownWordsChange($event)" disableRipple>Use known words list</mat-checkbox>

          <div class="analysis-known-words-select" style="margin-right: 10px; margin-left: 12px;">
            <select id="listSelect" name="listSelect" class="custom-select" [(ngModel)]="wordlistselect" style="width: 120px; margin-bottom: 0px;" (change)="onWordlistChange($event)"> 
              <option *ngFor="let lista of nombresListas" [value]="lista.id">{{ lista.nombre }}</option>
            </select>
          </div>
          <div class="span_new_word">
            <u (click)="createList()">Create New Known Word List</u>
            <div class="tooltip-container">
              <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
              <span class="tooltip-text2">You can create a new set of 'known words' which will be ignored in analysis. This is particularly useful if your text is domain-specific, and certain specific terminology is overrepresented compared to the normal population. For example, if you are teaching a group of doctors who will be more familiar with complex medical terms than the average person.</span>
            </div>
          </div>
        </div>
      </div>
    </mat-dialog-content>
  </ng-template>
</ng-container>

<!--------------->
<!-----MOBILE---->
<!--------------->


<ng-template #mobileLayout>
  <span style="padding-left: 15px;">
    <button mat-button (click)="openAnalysisOptions(analysisOptionsDialog)" [disabled]="isCreatingProject"
      style="color: #EEA21A; font-size: 14px; font-family: 'Inter'; font-weight: 600;">
      <img style=" 
      padding-bottom: 4px;
      vertical-align: middle;
      height: 20px;
      width: 20px;" src="./assets/images/yellow_icons/analysis-icon.svg">
      Analysis Options
    </button>
  </span>

  <ng-template #analysisOptionsDialog>

    <div
      style="background-color: #F3F3F5;width: auto; height: auto; display: flex; justify-content: flex-end; padding: 0; margin: 0;">
      <button class="close-button" mat-dialog-close>
        <img src="./assets/images/close-icon.svg">
      </button>
    </div>




    <mat-dialog-content class="mat-dialog-content">

      <div class="select-container">
        <label for="englishType">English type</label>
        <select id="englishType" name="englishType" class="custom-select" [value]="englishType"
          (change)="onEnglishTypeChange($event)">
          <option value="british">British English</option>
          <option value="american">American English</option>
        </select>
      </div>

      <div style="display: flex; flex-direction: column; align-items: flex-start; width: 100%;">

        <div class="select-container">
          <label for="analysisMode">Analysis mode</label>
          <select id="analysisMode" name="analysisMode" class="custom-select" [value]="analysisMode"
            (change)="onAnalysisModeChange($event)">
            <option value="Reading">Reading</option>
            <option value="Writing">Writing</option>
            <option value="Listening">Listening</option>
          </select>
        </div>
      </div>

      <div style="display: flex; flex-direction: column; align-items: flex-start; width: 100%;">

        <div class="select-container">
          <label for="targetCEFR">Target overall CEFR Score for your text</label>
          <select id="targetCEFR" name="targetCEFR" class="custom-select" [value]="targetCEFR"
            (change)="onTargetCEFRChange($event)">
            <option value="A1">A1</option>
            <option value="A2">A2</option>
            <option value="B1">B1</option>
            <option value="B2">B2</option>
            <option value="C1">C1</option>
            <option value="C2">C2</option>
          </select>
        </div>
      </div>

      <button class="main-box-value-14 button-settings" style="color:#EEA21A; text-align: center; align-items: center;"
        [ngClass]="{'expanded': isExpanded}" (click)="toggleExpand()">Advanced Settings <mat-icon class="expand-icon"
          style="order:3;">expand_more</mat-icon></button>

      <div *ngIf="isExpanded">
        <div style="display: flex; flex-direction: column; align-items: flex-start;margin-top: 15px;">
          <span for="sizeType">Split documents at this character
            <div class="tooltip-container">
              <img class="tooltip-icon" src="../assets/images/tooltip-icon.svg">
              <span class="tooltip-text">You can input multiple texts into Text Inspector. This option allows you to choose which character serves as a delimiter between each text.</span>
            </div>
          </span>

          <div class="custom-text-container">
             <input 
              type="text" 
              id="customInput" 
              class="custom-text-input" 
              [(ngModel)]="splitCharacter"  
              [readonly]="isProjectCreated"
              [ngStyle]="{ 'pointer-events': isProjectCreated ? 'none' : 'auto' }"
              (change)="onSplitCharacterChange($event)">
          </div>
        </div>
        <mat-checkbox color="accent" [checked]="excludeDigits" (change)="onExcludeDigitsChange($event)" disableRipple>Exclude all digits</mat-checkbox>
        <div class="horizontal-box" style="border: none; padding: 0px; margin-bottom: 0px; ">
          <mat-checkbox color="accent" [checked]="useKnownWords" (change)="onUseKnownWordsChange($event)" disableRipple>Use known words list</mat-checkbox>
          <div>
            <select id="listSelect" name="listSelect" class="custom-select" [(ngModel)]="wordlistselect" style="width: 120px; margin-bottom: 0px;" (change)="onWordlistChange($event)">
              <option *ngFor="let lista of nombresListas" [value]="lista.id">{{ lista.nombre }}</option>
            </select>
          </div>
        </div>
        <div class="span_new_word">
          <u (click)="createList()">Create New Known Word List</u>
          <div class="tooltip-container">
            <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
            <span class="tooltip-text2">You can create a new set of 'known words' which will be ignored in analysis. This is particularly useful if your text is domain-specific, and certain specific terminology is overrepresented compared to the normal population. For example, if you are teaching a group of doctors who will be more familiar with complex medical terms than the average person.</span>
          </div>
        </div>
      </div>
    </mat-dialog-content>
  </ng-template>

</ng-template>
